import { Input } from "@alme/ui-web/types/input";
import { Store } from "redux";
import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";
import { AlightStateType } from "../../types/alight-state";
import { PlatformInformationState } from "../../types/platform-information-state";

export default class InitializationDataRequestProcessor {
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlightStateType>): void{
        this._store = store;
    }

    process(input: Input): Input & { parameters: any } {
        let inputParameters: any = {};
        if (input.parameters) {
            inputParameters = input.parameters;
        }

        const platformInformationState = {} as PlatformInformationState;
        platformInformationState.userAuthenticated = false;

        if(window.enableIVAasService) {
            platformInformationState.ServiceType = "IVAaaS";

            const initData = this._store?.getState().Window.initializationData;
            if(initData) {
                platformInformationState.multiTenantId = initData.multiTenantId;
                
                platformInformationState.UUID = this._store?.getState().Window.UDPVars?.UUID ?? initData.UUID ?? undefined;
                platformInformationState.PlatformId = initData.platformId;
                platformInformationState.userAuthenticated = initData.userAuthenticated; 
                platformInformationState.enableSecureAwsConfig = initData.enableSecureAwsConfig ?? "false";
                platformInformationState.companyId = initData.companyId;

                if(initData.testCfg !== undefined){
                    platformInformationState.testCfg = initData.testCfg;
                }
                if(initData.testCfgMap !== undefined){
                    platformInformationState.testCfgMap = initData.testCfgMap;
                }
                if(initData.subjectType !== undefined){
                    platformInformationState.subjectType = initData.subjectType;
                }
                platformInformationState.metadata = initData.metadata;

                // ALIGHT-12036 - Temporary workaround for mobile app not having userAuthenticated flag
                if (this._store?.getState()?.Conversation?.Channel == this._settings.channelConstants.channels.MobileApp){
                    platformInformationState.userAuthenticated = true;
                }
            }
        }
        else if(window.enableIVA2Features) {
            platformInformationState.ServiceType = "Payload";

            if (this._store && this._store.getState().Window.UDPVars){
                platformInformationState.UUID = this._store.getState().Window.UDPVars.UUID ?? undefined;
            }

            const productPayloadState = this._store?.getState().Window.productPayload;

            if (productPayloadState && productPayloadState.generalConfigData) {
                platformInformationState.multiTenantId = productPayloadState.generalConfigData.multiTenantId;
                platformInformationState.gcc = productPayloadState.generalConfigData.gcc;
                platformInformationState.lcc = productPayloadState.generalConfigData.lcc;
                platformInformationState.employeeId = productPayloadState.generalConfigData.employeeId;
                platformInformationState.testCfg = productPayloadState.generalConfigData.testCfg;
                platformInformationState.testCfgMap = productPayloadState.generalConfigData.testCfgMap;
                platformInformationState.roleId = productPayloadState.generalConfigData.roleId;
                platformInformationState.userAuthenticated = productPayloadState.generalConfigData.userAuthenticated;
                platformInformationState.enableNewUDPEndPoint = productPayloadState.generalConfigData.enableNewUDPEndPoint ?? "false";
                platformInformationState.enableSecureAwsConfig = productPayloadState.generalConfigData.enableSecureAwsConfig ?? "false";
                platformInformationState.companyId = productPayloadState.generalConfigData.companyId;
            }
        }

        if (!inputParameters.Context) {
            inputParameters.Context = {};
        }

        inputParameters.Context.PlatformInformationState = platformInformationState;

        return Object.assign({}, input, { parameters: inputParameters });
    }
}



// WEBPACK FOOTER //
// ./modules/request-processor-initialization-data/request-processor-initialization-data.ts